// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { connect } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import { bindActionCreators } from "redux";
import { elementContains, Spinner, SpinnerSize } from "office-ui-fabric-react";
import IUserModelActions, * as userModelActions from "../../../../redux/actions/modalActions";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import { IProject, IAuthenticationState, IApplicationState, IConnection, IAzureFields } from "../../../../models/applicationState";
import HeaderComponent from "../header/header";
import size from "lodash/size";
import IFilesUploadingAction, * as filesUploadingAction from "../../../../redux/actions/filesUploadingAction";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import MyModels from "../myModels/myModels";
import axios from "axios";
import { accessToken } from "../../../../common/api-config";

import base64 from "base-64";
import { toast } from "react-toastify";
import Select from "react-select";
import filterIcon from "../../../../assets/images/Filter-icon.svg";

import "./invoicemanagement.scss";

export interface IInvoiceManagementProps extends RouteComponentProps, React.Props<InvoiceManagement> {
  userModelActions: IUserModelActions;
  loggedInUser: IAuthenticationState;
  userOperationsActions: IUserOperationsActions;
  filesUploadingAction: IFilesUploadingAction;
  actions: IProjectActions;
  project: IProject;
  recentProjects: IProject[];
  path: object;
  projectActions: IProjectActions;
  userModels: any;
}

export interface IInvoiceManagementState {

  userId: string;
  connection: IConnection;
  myModels: any;
  loadModal: boolean;
  showDate: boolean;
  allData: any;
  loaderText: string;
  loadingProjects: boolean;
  selectedFilter: any;
  invoiceWithOrwithoutPO: String;
  selectedRecords: any;
  fromDate: any;
  toDate: any;
  loadProcess: boolean;
  appliedFilters: any;
  companyFilter: boolean;
  vendorFilter: boolean;
  irFilter:boolean;
  searchText: null;


}

function mapDispatchToProps(dispatch) {
  return {
    userModelActions: bindActionCreators(userModelActions, dispatch),
    userOperationsActions: bindActionCreators(userOperationsActions, dispatch),
    filesUploadingAction: bindActionCreators(filesUploadingAction, dispatch),
    actions: bindActionCreators(projectActions, dispatch),
  };
}

function mapStateToProps(state: IApplicationState) {
  return {
    loggedInUser: state.loggedInUser,
  };
}
@connect(mapStateToProps, mapDispatchToProps)

export default class InvoiceManagement

  extends React.Component<IInvoiceManagementProps, IInvoiceManagementState> {


    greenCheck:boolean;
    redCheck: boolean;
    yellowCheck: boolean;

  public state: IInvoiceManagementState = {
    userId: null,
    connection: { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} },
    myModels: [],
    loadModal: false,
    showDate: false,
    loadProcess: false,
    allData: [],
    loaderText: "Loading file to preview",
    loadingProjects: false,
    selectedFilter: '',
    invoiceWithOrwithoutPO: '',
    selectedRecords: [],
    fromDate: '',
    toDate: '',
    appliedFilters: [],
    companyFilter: false,
    vendorFilter: false,
    irFilter:false,
    searchText: null

  };
  records = [];
  green_selected:boolean;
  yellow_selected:boolean;
  red_selected:boolean;
  with_po_selected:boolean;
  without_po_selected:boolean;


  constructor(props) {
    super(props);
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate()
    let currentDate = year + "-" + month + "-" + day
    this.setState({ fromDate: currentDate })
  }

  handleClick(event) {
    if (event.target.nodeName === 'INPUT' && event.target.parentElement.nodeName === 'TH') {
      let tbody = document.getElementsByTagName('tbody')[0]
      let checks = tbody.getElementsByTagName('input')
      if (event.target.checked) {
        for (let i = 0; i < checks.length; i++) {
          checks[i]['checked'] = true;
        }
        this.setState({ selectedRecords: this.state.myModels })
      }
      else {
        for (let i = 0; i < checks.length; i++) {
          checks[i]['checked'] = false;
        }
        this.setState({ selectedRecords: [] })

      }
    }

  }

  handleChange = (event) => {
    if (event.target.value == 'WO_PO') {
      const result = this.state.allData.filter(element => element.po_number.trim() == '');
      this.setState({
        selectedFilter: event.target.value, myModels: result
      });
    }
    if (event.target.value == 'WPO') {
      const result = this.state.allData.filter(element => element.po_number.trim() != '');
      this.setState({
        selectedFilter: event.target.value, myModels: result
      });
    }
    if (event.target.value == 'WO_IR') {
      const result = this.state.allData.filter(element => element.invoice_receipt_number.trim() == "");
      this.setState({
        selectedFilter: event.target.value, myModels: result
      });
    }
    if (event.target.value == 'WIR') {
      const result = this.state.allData.filter(element => element.invoice_receipt_number.trim() != "");
      this.setState({
        selectedFilter: event.target.value, myModels: result
      });
    }
    if (event.target.value == 'WPR') {
      const result = this.state.allData.filter(element => element.PR_number.trim() != '');
      this.setState({
        selectedFilter: event.target.value, myModels: result
      });
    }
    if (event.target.value == 'WO_PR') {
      const result = this.state.allData.filter(element => element.PR_number.trim() == '');
      this.setState({
        selectedFilter: event.target.value, myModels: result
      });
    }
  }

  handleSingleCheck(model) { 
    if (this.records.length > 0) {
      let present = false;
      for (var i = 0; i < this.records.length; i++) {
        if (this.records[i].Filename == model.Filename) {
          present = true;
          this.records.splice(i, 1);
          break;
        }
      }

      if (!present) {
        this.records.push(model)
      }
    } else {
      this.records.push(model)
    }

    this.setState({ selectedRecords: this.records })

  }

  green(){
    this.green_selected=!this.green_selected;
  this.yellow_selected=false;
  this.red_selected=false;
  this.with_po_selected=false;
  this.without_po_selected= false;
    if(this.green_selected){
      const result = this.state.allData.filter(element => element.invoice_receipt_number.trim() != "");
      this.setState({
       myModels: result
      });
    }else{
      this.setState({
        myModels: this.state.allData
    })}
   
    // var items=document.getElementsByName('yellow');
		// 		for(var i=0; i<items.length; i++){
		// 			if(items[i]['type']=='checkbox')
		// 				items[i]['checked']=false;
    //     }
    //     var items=document.getElementsByName('red');
		// 		for(var i=0; i<items.length; i++){
		// 			if(items[i]['type']=='checkbox')
		// 				items[i]['checked']=false;
    //     }
    //     this.yellowCheck = false;
    //     this.redCheck = false;

    // this.greenCheck = !this.greenCheck

    // if( this.greenCheck){
    //   const result = this.state.allData.filter(element => element.invoice_receipt_number.trim() != "");
    //   this.setState({
    //    myModels: result
    //   });
    // }else{
    //   this.setState({
    //     myModels: this.state.allData
    //   })
    // }

   

  }
  yellow(){ 
    this.green_selected=false;
    this.yellow_selected=!this.yellow_selected;
    this.red_selected=false;
    this.with_po_selected=false;
    this.without_po_selected= false;
    if(this.yellow_selected){
    const result = this.state.allData.filter(element =>  element.invoice_receipt_number.trim() == "")
      this.setState({
       myModels: result
      });
    }else{
      this.setState({
        myModels: this.state.allData
    })}

    // var items=document.getElementsByName('red');
		// 		for(var i=0; i<items.length; i++){
		// 			if(items[i]['type']=='checkbox')
		// 				items[i]['checked']=false;
    //     }
    //     var items=document.getElementsByName('green');
		// 		for(var i=0; i<items.length; i++){
		// 			if(items[i]['type']=='checkbox')
		// 				items[i]['checked']=false;
    //     }
    //     this.greenCheck = false;
    //     this.redCheck = false;
    // this.yellowCheck = ! this.yellowCheck;
    // if( this.yellowCheck){
      
    //   const result = this.state.allData.filter(element =>  element.invoice_receipt_number.trim() == "")
    //   this.setState({
    //    myModels: result
    //   });
    // }else{
    //   this.setState({
    //     myModels: this.state.allData
    //   })
    // }

  }
  red(){
    this.green_selected=false;
    this.yellow_selected=false;
    this.red_selected=!this.red_selected;
    this.with_po_selected=false;
    this.without_po_selected= false;
    if(this.red_selected){
    this.setState({
      myModels: []
     });}else{
      this.setState({
        myModels: this.state.allData
    })
     }
    // var items=document.getElementsByName('yellow');
    // for(var i=0; i<items.length; i++){
    //   if(items[i]['type']=='checkbox')
    //     items[i]['checked']=false;
    // }
    // var items=document.getElementsByName('green');
    // for(var i=0; i<items.length; i++){
    //   if(items[i]['type']=='checkbox')
    //     items[i]['checked']=false;
    // }
    // this.greenCheck = false;
    // this.yellowCheck = false;
    // this.redCheck =! this.redCheck


    // if(this.redCheck){
    //   this.setState({
    //     myModels: []
    //    });
    // }else{
    //   this.setState({
    //     myModels: this.state.allData
    //    });
    // }

    

  }

  with_po(){ 
    this.green_selected=false;
    this.yellow_selected=false;
    this.red_selected=false;
    this.with_po_selected=!this.with_po_selected;
    this.without_po_selected= false;
    if(this.with_po_selected){
    const result = this.state.allData.filter(element =>  element.po_number.trim() != '')
      this.setState({
       myModels: result
      });
    }else{
      this.setState({
        myModels: this.state.allData
    })}

  }

  without_po(){ 
    this.green_selected=false;
    this.yellow_selected=false;
    this.red_selected=false;
    this.with_po_selected=false;
    this.without_po_selected= !this.without_po_selected;
    if(this.without_po_selected){
    const result = this.state.allData.filter(element =>  element.po_number.trim() == '')
      this.setState({
       myModels: result
      });
    }else{
      this.setState({
        myModels: this.state.allData
    })}

  }

  public openCompayFilter() {
    this.setState({ companyFilter: !this.state.companyFilter })
  }

  public openVendorFilter() {
    this.setState({ vendorFilter: !this.state.vendorFilter })
  }
  public openIRFilter() {
    this.setState({ irFilter: !this.state.irFilter })
  }
  

  public async componentDidMount() {
    const user = this.props.loggedInUser;
    const userId = user.user.oid;
    await this.setState({ loadModal: true, userId });
    localStorage.removeItem("lastVisttedtestAssetId");
    localStorage.removeItem("filesLength");
    localStorage.removeItem("testFilesLengthFromTest");
    localStorage.removeItem("filesLengthFromModel");
    this.setState({ loadModal: true });
    const modelData = await this.props.userOperationsActions.invoiceManagement();
    this.setState({ loadModal: false, myModels: modelData, allData: modelData });

  }

  public searchSpace = (e) => {
    const keyword = e.target.value;
    this.setState({ searchText: keyword });
    if (keyword === "") {
        this.setState({ myModels: this.state.allData });
        this.tableDataShow();
    } else {
        let result = this.state.allData;
    result = result.filter(element => element.invoice_receipt_number.trim().toUpperCase().startsWith(keyword.toUpperCase()) ||     element.company_name.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.invoice_receipt_number.trim().toUpperCase().startsWith(keyword.toUpperCase()) ||  element.Status_Error_msgs.trim().toUpperCase().startsWith(keyword.toUpperCase())  ||  element.PR_number.trim().toUpperCase().startsWith(keyword.toUpperCase())|| element.Vendor_Invoice_Number.trim().toUpperCase().startsWith(keyword.toUpperCase()) ||  element.po_number.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.invoice_date.trim().toUpperCase().startsWith(keyword.toUpperCase()));
    this.setState({ myModels: result })
        
    }
}
  private getType = (event) => {
    console.log(event)
    this.green_selected=false;
    this.yellow_selected=false;
    this.red_selected=false;
    let result = this.state.allData;
    if ( event!=null && event.value === 'FI') {
      result = result.filter(element => element.po_number.trim() == '');
    }
    if ( event!=null && event.value === 'UI') {
      result = result.filter(element => element.po_number.trim() != '');
    }
    // event.forEach(element => {
     
      
    // })
    this.setState({ myModels: result })
    if (event) {
      this.setState({ appliedFilters: event });
    } else {
      this.setState({ appliedFilters: [] });
    }


  }

  public tableDataShow = () => {
    const { myModels } = this.state;
    return (
      <div>
        {/* {myModels && size(myModels) > 0 ? */}
        <div className="card wrap-body-my_models shadow model-data mt-2">
          <table className="table table-dark table-striped" style={{fontSize:'12px'}}>
            <thead>
              <tr>
                <th style={{ width: '50px' }}><input type="checkbox" onClick={this.handleClick.bind(this)} /></th>
                <th style={{ width: "1000px", tableLayout: "fixed" }} >File Name</th>
                <th style={{ width: "1000px", tableLayout: "fixed" }}>Company Name </th>
                <th style={{ width: "900px", tableLayout: "fixed" }}>Vendor Name  </th>
                <th style={{ width: "850px", tableLayout: "fixed" }}>Vendor Invoice No.</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>PO No.</th>
                <th style={{ width: "750px", tableLayout: "fixed" }}>IR No.</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>Invoice Date</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>PR No.</th>
                <th style={{ width: "700px", tableLayout: "fixed" }}>Recipient Name</th>
                <th style={{ width: "100px", tableLayout: "fixed" }}>Messages</th>
                <th style={{ width: "100px", tableLayout: "fixed" }}>Status</th>
                <th style={{ width: "100px", tableLayout: "fixed" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {myModels && myModels.map((model, index) => {
                return (
                  <tr key={index}>
                    <td><input type="checkbox" onClick={() => this.handleSingleCheck(model)}  /></td>
                    <td>{model.Filename}</td>
                    <td>
                      {model.company_name}
                    </td>
                    <td>
                      {model.vendor_name}
                    </td>
                    <td>
                      {model.Vendor_Invoice_Number}
                    </td>
                    <td>
                      {model.po_number}
                    </td>
                    <td>
                      {model.invoice_receipt_number}
                    </td>
                    <td>{model.invoice_date}</td>
                    <td>{model.PR_number}</td>
                    <td>{model.receipt_name}</td>
                    <td>{model.Status_Error_msgs}</td>
                    <td>
                      {model.invoice_receipt_number.trim() == "" ?
                        <span>
                        <i className="fa fa-circle" style={{ fontSize: '8px', padding: '1px' }}></i>
                        <i className="fa fa-circle" style={{ fontSize: '8px', color: 'orange', padding: '1px' }}></i>
                        <i className="fa fa-circle" style={{ fontSize: '8px', padding: '1px' }}></i>
                      </span> :<span>
                          <i className="fa fa-circle" style={{ fontSize: '8px', padding: '1px' }}></i>
                          <i className="fa fa-circle" style={{ fontSize: '8px', padding: '1px' }}></i>
                          <i className="fa fa-circle" style={{ fontSize: '8px', color: 'green', padding: '1px' }}></i>
                        </span> }
                    </td>
                    <td className="action-control">
                      <button role="button" className="view"
                        onClick={() => this.goToModel(model)}>
                        <i className="fa fa-edit bg-color-1" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* // : <p className="text-center">No Data Available</p>
          } */}
      </div>
    );
  }


  public render() {
    const ocrOptions = [
      { value: 'FI', label: 'Freight Invoices' },
      { value: 'UI', label: 'Utility Invoices' },
     

    ];
    return (
      <>
        <HeaderComponent
          history={this.props.history}
          match={this.props.match}
          location={this.props.location} />
        <LoadingOverlay
          active={this.state.loadingProjects}
          spinner
          className={this.state.loadingProjects ? "wrap-queue-height" : ""}
          text={this.state.loaderText}
        >

          {this.state.loadModal ? <Spinner
            size={SpinnerSize.large}
            label={this.state.loaderText}
            ariaLive="off"
            className="mt-5"
            labelPosition="bottom"
          /> :
            <div className="container-fluid animated fadeIn">
              {this.state.loadProcess ? <Spinner
                size={SpinnerSize.large}
                label={this.state.loaderText}
                ariaLive="off"
                className="mt-5"
                labelPosition="bottom"
              /> : <div className="row mt-2">
                <div  className="col-md-12">
                  <div style={{display:'flex'}}>
                  <input type="text" placeholder="search"  onChange={(e) => this.searchSpace(e)}  style={{background:'#222830', border:'1px solid #222830', color:'lightgray', width:'100%', borderRadius:'3px', padding:'5px'}} />  <i className="fas fa-search" style={{marginLeft:'-2%', marginTop:'8px'}}></i>
                
                    </div>
              <hr style={{border: "solid 0.05px #92918e"}}></hr>
                  </div>
                 
                  <div className="col-md-9">
                    <div className="input-group input-group-sm my-model-filter ">
                      <div className="col-md-3">
                        <div style={{color: 'lightgray'}}>
                          Invoices Types
                          </div>
                        <Select options={ocrOptions}
                          value={this.state.appliedFilters}
                          onChange={this.getType}
                          className="react-select-container z-index-19"
                          isClearable={true}
                          placeholder="Invoices Types"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#161a1f",
                              primary: "#6b727d",
                              neutral0: "#222830",
                              neutral20: "#44474c",
                              neutral30: "#272c33",
                              neutral50: "#fff",
                              neutral80: "#9da7b5",
                            },
                          })}

                        />
                      </div>
                      <div className="col-md-5">
                        <div style={{color: 'lightgray'}}>
                          Date
                          </div>
                          <div  style={{ display: 'inline-flex' }}>
                          <div>
                        <input type="date"  placeholder="From Date"     style={{background:'#222830', border:'1px solid #222830', color:'lightgray', padding:'17px', borderRadius:'4px'}}
                          
                          maxLength={20} minLength={4} onChange={(e) => this.fromDateChange(e)} name="createModel" />
                      </div> &nbsp; &nbsp;
                  <div style={{ display: 'inline-flex' }}>
                          <input type="date"  placeholder=" To Date "   style={{background:'#222830', border:'1px solid #222830', color:'lightgray', padding:'17px', borderRadius:'4px'}}
                          maxLength={20} minLength={4} onChange={(e) => this.toDateChange(e)} name="createModel" />
                      </div>
                            </div>
                        </div>
                     
                    
                    <div  className="col-md-4">
                      <div style={{color: 'lightgray'}}>
                       Status
                        </div>
                        <div style={{marginTop:'2%'}}>
                        <span>
                          <span  onClick={this.green.bind(this)}>{this.green_selected?<i className="fa fa-circle" style={{ fontSize: '15px', color: 'green', padding: '1px' }}></i>: <i className="fa fa-circle" style={{ fontSize: '15px', color: 'white', padding: '1px' }}></i>} Processed</span> &nbsp;
                          <span  onClick={this.yellow.bind(this)}>{this.yellow_selected?<i className="fa fa-circle" style={{ fontSize: '15x', color: 'orange', padding: '1px' }}></i>: <i className="fa fa-circle" style={{ fontSize: '15px', color: 'white', padding: '1px' }}></i>} In Process</span>&nbsp;

                          <span  onClick={this.red.bind(this)}>{this.red_selected?<i className="fa fa-circle" style={{ fontSize: '15px', color: 'red', padding: '1px' }}></i>: <i className="fa fa-circle" style={{ fontSize: '15px', color: 'white', padding: '1px' }}></i>} Error</span><br></br>
                          {/* <span  onClick={this.with_po.bind(this)}>{this.with_po_selected?<i className="fa fa-circle" style={{ fontSize: '15px', color: 'blue', padding: '1px' }}></i>: <i className="fa fa-circle" style={{ fontSize: '15px', color: 'white', padding: '1px' }}></i>} with po</span>&nbsp;
                          <span  onClick={this.without_po.bind(this)}>{this.without_po_selected?<i className="fa fa-circle" style={{ fontSize: '15px', color: 'blue', padding: '1px' }}></i>: <i className="fa fa-circle" style={{ fontSize: '15px', color: 'white', padding: '1px' }}></i>} without po</span> */}



                      {/* <label  id='x' style={{verticalAlign:'middle',display:'inline-block' , paddingRight:'10px' , whiteSpace:'nowrap'}}><input type="radio" id="x"  name="green" style={{verticalAlign:'middle'}} onClick={this.green.bind(this)} checked={this.greenCheck} /> <span style={{verticalAlign:'middle'}}>Green</span></label>
    <label   id='y' style={{verticalAlign:'middle',display:'inline-block' , paddingRight:'10px' , whiteSpace:'nowrap'}} ><input type="radio" id="y" name="green"  style={{verticalAlign:'middle'}}  onClick={this.yellow.bind(this)} checked={this.yellowCheck}/> <span style={{verticalAlign:'middle'}}>Yellow</span></label>
    <label   id='z'  style={{verticalAlign:'middle',display:'inline-block' , paddingRight:'10px' , whiteSpace:'nowrap'}}><input type="radio" id="z" name="green" style={{verticalAlign:'middle'}}   onClick={this.red.bind(this)} checked={this.redCheck}/> <span style={{verticalAlign:'middle'}}>Red</span></label>
                         */}
                 </span>
                        </div>
                      </div>
                      
                    </div>
                    
                  </div>
                  <div className="col-md-3" style={{ marginTop: '20px' }}>
                    
                    <button className="btn-custom float-right" onClick={() => this.invoiceWO_PO()} style={{ marginRight: '1%', fontWeight: 'bold', borderRadius:'5px' }}>
                      Process w/o PO </button>
                    <button className="btn-custom float-right" onClick={() => this.invoiceW_PO()} style={{ marginRight: '1%', fontWeight: 'bold', borderRadius:'5px' }}>
                      Process with PO </button>&nbsp;&nbsp;
                      <span className="float-right" onClick={() => this.updateModels(true)} style={{ fontWeight: 'bold', marginTop:'3%', marginRight:'2%',  borderRadius:'5px', color:'#e0bb36'  }} >
                      <i className="fas fa-sync-alt"></i> Refresh </span> &nbsp;&nbsp;
                  </div>
                </div>}
              {this.tableDataShow()}
            </div>
          }

        </LoadingOverlay>
      </>
    );
  }

  /**
   * Get Queue Data
   */
  public goToModel = async (model) => {
    localStorage.setItem("selectedFile", JSON.stringify(model));
    this.props.history.push(`/editTagsForInv`);
  }
  /**
  * get updated models
  */
  private updateModels = async (flag?: boolean) => {
    this.records=[];
    this.green_selected=false;
    this.yellow_selected=false;
    this.red_selected=false;
    this.setState({ loadModal: true, selectedFilter: '', loaderText: 'Loading file to preview', appliedFilters: '' });
    const modelData = await this.props.userOperationsActions.invoiceManagement();
    this.setState({ loadModal: false, myModels: modelData, allData: modelData });
  }

  private fromDateChange = (event) => {
    this.setState({ fromDate: event.target.value })
    if (this.state.toDate != '') {
      var startDate = new Date(event.target.value);
      var endDate = new Date(this.state.toDate);
      console.log(event.target.value)
      console.log(startDate)
      console.log(endDate)
      var resultProductData = this.state.allData.filter(a => {
        let date1 = a.invoice_date.split("/").reverse().join("-")
        console.log(date1)
        var date = new Date(date1);
        console.log(date)
        return (date >= startDate && date <= endDate);
      });
      this.setState({ myModels: resultProductData })
      console.log(resultProductData)
    }
  }

  private toDateChange = (event) => {
    this.setState({ toDate: event.target.value })
    if (this.state.fromDate != '') {
      var startDate = new Date(this.state.fromDate);
      var endDate = new Date(event.target.value);
      console.log(event.target.value)
      console.log(startDate)
      console.log(endDate)
      var resultProductData = this.state.allData.filter(a => {
        let date1 = a.invoice_date.split("/").reverse().join("-")
        console.log(date1)
        var date = new Date(date1);
        console.log(date)
        return (date >= startDate && date <= endDate);
      });
      this.setState({ myModels: resultProductData })
      console.log(resultProductData)
    } else {
      alert("Please select from date")
    }
  }

  private getrelatedCompanyData = (event) => {
    let result = this.state.allData;
    result = result.filter(element => element.company_name.trim().includes(event.target.value));
    this.setState({ myModels: result })

  }

  private getrelatedIRData = (event) => {
    let result = this.state.allData;
    result = result.filter(element => element.invoice_receipt_number.trim().includes(event.target.value));
    this.setState({ myModels: result })
  }

  

  private getrelatedVendorData = (event) => {
    let result = this.state.allData;
    result = result.filter(element => element.vendor_name.trim().includes(event.target.value));
    this.setState({ myModels: result })
  }
  private invoiceW_PO = () => {
    this.setState({ loadProcess: true, loaderText: "Invoice receipt is being created" });
    let response;
    let AuthResp;
    // S49 system
    // let endpointURL = 'https://MHANA03.MOURITECH.NET:50100/sap/opu/odata/sap/ZMIRO_INVOICE_DELEK_SRV/INV_HeaderSet';

    // S4C system

    let endpointURL= 'https://mhana09.mouritech.net:50100/sap/opu/odata/sap/ZMIRO_INVOICE_DELEK_SRV/INV_HeaderSet'
    // let endpointURL= 'https://mhana09.MOURITECH.NET:50100/sap/opu/odata/sap/ZMIRO_INVOICE_DELEK_SRV/INV_HeaderSet'
    if (this.state.selectedRecords.length > 0) {
      this.state.selectedRecords.forEach(element => {
        try {
          var encodedData = base64.encode("DCAP_BATCH" + ":" + "Welcome@123");
          const headers = {
            "x-csrf-token": "fetch",
            "Access-Control-Expose-Headers": "*",
            "Access-Control-Allow-Origin":"*",
            "Access-Control-Allow-Headers":"*",
            "Authorization":"Basic "+encodedData,
            "X-Requested-With": "X",
            "Content-Type": "application/json",
           'Access-Control-Allow-Methods':'POST',
          };
          let body = element.sap_output.replace(/'/g, '"')

          axios(endpointURL, { method: "POST", data: body, headers }).
            then((resp) => {
              if (resp.status === 200 || resp.status === 201) {
                axios(`https://fa-ai-dcap-prod-copy.azurewebsites.net/api/update_invoice_dp?file_name=${element.Filename}&user_id=${this.state.userId}&invoice_ir_no=${resp.data['d']["Invoice_No"]}`, { method: "GET", headers }).then((resp1) => {
                  axios(`https://fa-ai-dcap-prod-copy.azurewebsites.net/api/update_invoice_dp?file_name=${element.Filename}&user_id=${this.state.userId}&receipt_num=${resp.data['d']["Recipient"]}`, { method: "GET", headers }).then((resp2) => {
                    this.setState({ loadProcess: false });
                    toast.success(`IR is created`, { position: toast.POSITION.TOP_CENTER });
                    this.records=[]
                    this.setState({ selectedRecords: [] })
                    this.updateModels();
                  })
                })
              }
            })
            .catch((error) => {
            });
        } catch (error) {
          toast.error(`Sap end point fialed`, { position: toast.POSITION.TOP_CENTER });
        }
      })
    } else {
      this.setState({ loadProcess: false })
      toast.warn(`Please select atleast one record to process`, { position: toast.POSITION.TOP_CENTER });
    }

  }

  private invoiceWO_PO = () => {
    this.setState({ loadProcess: true, loaderText: "Purchase receipt is being created" });
    let headers = accessToken()
    // S49 system
    // let endpointURL = 'https://MHANA03.MOURITECH.NET:50100/sap/opu/odata/sap/ZPR_CREATION_SRV/PR_HeaderSet';

    // S4C system
    let endpointURL = 'https://mhana09.MOURITECH.NET:50100/sap/opu/odata/sap/ZPR_CREATION_SRV/PR_HeaderSet'
    if (this.state.selectedRecords.length > 0) {
      this.state.selectedRecords.forEach(element => {

        if (element.PR_number.trim() == "") { 
          try {
            var encodedData = base64.encode("DCAP_BATCH" + ":" + "Welcome@123");
            const headers = {
              "X-Requested-With": "X",
              "Content-Type": "application/json",
              "Authorization": "Basic " + encodedData
            };
            let body = element.sap_output.replace(/'/g, '"')
            axios(endpointURL, { method: "POST", data: body, headers, }).
              then((resp) => {
                if (resp.status === 200 || resp.status === 201) {
                  axios(`https://fa-ai-dcap-prod-copy.azurewebsites.net/api/update_invoice_dp?file_name=${element.Filename}&user_id=${this.state.userId}&purchase_req=${resp.data['d']['PurchaseReq']}`, { method: "GET", headers }).then((resp1) => {
                    if (resp1.status === 200 || resp1.status === 201) {
                      this.setState({ loadProcess: false });
                      toast.success(`PR is created`, { position: toast.POSITION.TOP_CENTER });
                      this.records=[]
                      this.setState({ selectedRecords: [] });
                      this.updateModels();
                    }
                  })
                }
              })
              .catch((error) => {
              });
          } catch (error) {
            toast.error(`SAP not Successful..`, { position: toast.POSITION.TOP_CENTER });
          }
        } else {
          this.invoiceWO_PO1()
        }
      })
    } else {
      this.setState({ loadProcess: false })
      toast.warn(`Please select atleast one record to process`, { position: toast.POSITION.TOP_CENTER });
    }
  }

  private invoiceWO_PO1 = () => {
    this.setState({ loadProcess: true, loaderText: "PO is being created" });
    if (this.state.selectedRecords.length > 0) {
      this.state.selectedRecords.forEach(element => {
        try {
          var encodedData = base64.encode("DCAP_BATCH" + ":" + "Welcome@123");
          const headers = {
            "X-Requested-With": "X",
            "Content-Type": "application/json",
            "Authorization": "Basic " + encodedData
          };
          axios(`https://fa-ai-dcap-prod-copy.azurewebsites.net/api/view_from_invoice_table?user_id=${this.state.userId}&file_name=${element.Filename}&invoice_no=${element.invoice_no}`, { method: "GET", headers }).then((resp2) => {
            if (resp2.status === 200 || resp2.status === 201) {
              // S49 system
              // axios("https://mhana03.mouritech.net:50100/sap/opu/odata/sap/ZPR_CREATION_SRV/PR_InvoiceSet", { method: "POST", data: JSON.stringify(resp2.data), headers, }).

              // S4C system
              axios("https://mhana09.mouritech.net:50100/sap/opu/odata/sap/ZPR_CREATION_SRV/PR_INVOICESet", { method: "POST", data: JSON.stringify(resp2.data), headers, }).

                then((resp3) => {
                  if (resp3.status === 200 || resp3.status === 201) {
                    axios(`https://fa-ai-dcap-prod-copy.azurewebsites.net/api/update_invoice_dp?file_name=${element.Filename}&user_id=${this.state.userId}&po_num=${resp3.data['d']['PurchaseNo']}`, { method: "GET", headers }).then((resp4) => {
                      if (resp4.status === 200 || resp4.status === 201) {
                        toast.success(`PO is created`, { position: toast.POSITION.TOP_CENTER });
                        axios(`https://fa-ai-dcap-prod-copy.azurewebsites.net/api/update_invoice_dp?file_name=${element.Filename}&user_id=${this.state.userId}&invoice_ir_no=${resp3.data['d']['Invoice_Rec']}`, { method: "GET", headers }).then((resp4) => {

                          if (resp4.status === 200 || resp4.status === 201) {
                            axios(`https://fa-ai-dcap-prod-copy.azurewebsites.net/api/update_invoice_dp?file_name=${element.Filename}&user_id=${this.state.userId}&receipt_num=${resp3.data['d']["Recipient"]}`, { method: "GET", headers }).then((resp4) => {
                              this.setState({ loadProcess: false });
                              this.records=[]
                              this.setState({ selectedRecords: [] })
                              this.updateModels();
                            })
                          }
                        })
                      }
                    })
                  }
                  else {
                    this.setState({ loadProcess: false });
                    toast.warn(`PO not created`, { position: toast.POSITION.TOP_CENTER });
                  }
                }).catch(error => {
                  this.setState({ loadProcess: false });
                  toast.warn(`PO not created`, { position: toast.POSITION.TOP_CENTER });
                });
            }
          })
        } catch (error) {
          toast.error(`SAP not Successful..`, { position: toast.POSITION.TOP_CENTER });
        }
      })
    } else {
      this.setState({ loadProcess: false })
      toast.warn(`Please select atleast one record to process`, { position: toast.POSITION.TOP_CENTER });
    }
  }

}
